import $ from "jquery";
import vuwer from "@@assets/scripts/vuwer";

vuwer.get("body").onReady($body => {
	$body.find(".image-hr").each((i, elm) => {
		const $elm = $(elm);
		const $cover = $elm.children(".cover-image");
		if($cover.length) {
			const $img = $cover.children("img");
			if($img.length) {
				$cover.css({
					"background-image": `url("${$img.attr("src")}")`
				});
				
			} else {
				$elm.remove();
			}
		}
	});
});
